import { HttpClient } from '@angular/common/http';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { catchError, map, of } from 'rxjs';
import { LoadingService } from '../../_services/loading.service';

export function podValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = (control.value || '').trim();

  return !value || /^(IT|it|iT|It)\d{3}(E|e)\d{8}[A-Z0-9]?$/.test(value)
    ? null
    : { pod: true };
}

export function podValidatorGSE(
  control: AbstractControl,
  field: FormlyFieldConfig,
  options: any,
): ValidationErrors | null {
  const value = (control.value || '').trim();
  if (!value) return of(null);

  if (value.toUpperCase() == 'IT000E00000000') return of(null);

  (options.loading as LoadingService).start();

  const url =
    'https://mappe.gse.it/srvf/rest/services/TIAD2/POD_AC/FeatureServer/12/query' +
    '?f=json&outFields=COD_AC&returnGeometry=false&spatialRel=esriSpatialRelIntersects&where=COD_POD%20%3D%20%27' +
    encodeURIComponent(value) +
    '%27';

  return (options.http as HttpClient).get<any>(url).pipe(
    map((res) => {
      console.log(res);
      console.log(options);
      console.log(
        res.features.some((el: any) => el.attributes.COD_AC == options.cod_ac),
      );
      (options.loading as LoadingService).stop();

      if (options.check) {
        return res.features.some(
          (el: any) => el.attributes.COD_AC == options.cod_ac,
        )
          ? null
          : { podGSECheck: true }; // null = valido
      } else {
        return res.features.length > 0 ? null : { podGSE: true }; // null = valido
      }
    }),
    catchError(() => {
      (options.loading as LoadingService).start();
      return of({ podGSE: true });
    }),
  );
}
